import React from 'react';

import { Breadcrumbs } from '../../../components/Breadcrumbs/Breadcrumbs';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { GetAllBrands_entry } from '../../../interfaces/graphql';

import { SearchBrands } from './SearchBrands';
import { NextPageWithLayout } from 'next';
import { MetaTags } from '../../../components/MetaTags/MetaTags';

export interface IAllBrandsProps {
  brands: GetAllBrands_entry[];
}

const BREADCRUMBS = [{ label: 'Brands', link: '/brands' }, { label: 'All Brands' }];

export const AllBrands: NextPageWithLayout<IAllBrandsProps> = ({ brands }) => (
  <Container>
    <MetaTags
      title="All Fishing Brands on Fishbrain"
      description="View all fishing brands and retailers. See what your favorite brands are up to on Fishbrain."
      link="/brands/all"
    />
    <Breadcrumbs items={BREADCRUMBS} />
    <Heading as="h1" variant="xl" className="mb-4">
      All Brands
    </Heading>
    <SearchBrands data-testid="all-brands" brands={brands} />
  </Container>
);
